import axios from 'axios';
import {API_BASE_URL, IQ_API_V2_BASE_URL} from '../config/apiConfig';
import api from './api';
import iq_auto_nurture_api from './iqAutoNurtureApi';
import qs from "qs";
import { formatDateToYMD } from '../utilities/dateUtils';

const iq_api_v2 = axios.create({
  baseURL: IQ_API_V2_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


// Add a request interceptor
iq_api_v2.interceptors.request.use(
  config => {
    // You can modify the config before sending the request, like adding authorization token
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // console.log('Request:', config); // Log the request for debugging
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
iq_api_v2.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      switch (error.response.status) {
        case 401:
          // Handle unauthorized access (e.g., redirect to login)
          console.error('Unauthorized access - perhaps redirect to login');
          break;
        case 403:
          // Handle forbidden access
          console.error('Forbidden access');
          break;
        case 404:
          // Handle not found
          console.error('Resource not found');
          break;
        case 500:
          // Handle internal server error
          console.error('Internal server error');
          break;
        default:
          // Handle other status codes
          console.error(`Error: ${error.response.status}`, error.response.data);
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error', error.message);
    }

    // Return a rejected promise to propagate the error
    return Promise.reject(error);
  }
);

export async function listMemories(userId,memoryType,opportunityId){
    try {
    const response = await iq_api_v2.get("/build_memory/list_memories", {
      params: { user_id: userId,memory_type:memoryType,opportunity_id:opportunityId },
    });
    return response?.data?.result;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
  }
}

export async function fetchConvertToWin(ids, userId,postCall=()=>null) {
  console.log("fetchConvertToWin ids", ids);
  try {
    const response = await iq_api_v2.post(
      "opportunities/convert_to_win",
      {
        opportunities_id: ids,
        user_id: userId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    postCall()
    return response?.data;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
  }
}

export async function markAsRelevant(ids, userId,postCall=()=>null) {
  console.log("markAsRelevant ids", ids);

  try {
    const response = await iq_api_v2.post(
      "opportunities/mark_as_relevant",
      {
        opportunity_ids: ids,
        user_id: userId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    postCall()
    return response?.data;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
  }
}


export async function deleteMemoryByRecordId(recordID) {
  console.log("deleteMemoryByRecordId ids", recordID);
  try {
    const response = await iq_api_v2.delete("build_memory/delete_memory", {
      params: {
        record_id: recordID
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
  }
}



export async function fetchSpotOpportunity(clientName, accountName, userId,type) {
  const data = {
    client: clientName,
    account: accountName,
    user_id: userId,
    type: type
  };

  // console.log("data",data)
  try {
    const response = await iq_api_v2.post('/opportunities/fetch', {}, {"params" : data} );
    // console.log("response : ", response);

    // console.log('Response:', response.data);
    return response?.data
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
  }
}

export async function fetchPitchWoOpportunity(opportunityId) {
  try {
    const response = await iq_api_v2.post('/opportunities/get_pitch', null, {
      params: { opportunity_id: opportunityId }
    });
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
  }
}


export async function handleRefreshMem({opportunityId}){
  const data = {
    opportunity_id: opportunityId,
  };

  // console.log("data",data)
  try {
    const response = await iq_api_v2.post('opportunities/refresh_opportunity_by_memory', {}, {"params" : data} );

    return response?.data
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
  }
}


export async function spotContactBC(contactId,userId) {
    try {
      const response = await iq_api_v2.get("spot_contacts/get_contact_details", {
        params: { contact_id: contactId,user_id:userId },
      });
      return response?.data;
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      throw error;
    }
  }

  

export async function getContactPsycoMetricData(contactId) {
    try {
      const response = await iq_api_v2.get("spot_contacts/get_contact_psychographic_details", {
        params: { contact_id: contactId },
      });
      return response?.data;
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      throw error;
    }
  }

export async function deleteOpportunity(userId, opportunityId) {
  try {
    const response = await iq_api_v2.delete("opportunities/delete", {
      params: {
        user_id: userId,
        opportunity_id: opportunityId,
      },
    });
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    throw error;
  }
}


export async function enrichContact(userId, apolloId, linkedInUrl,onSuccess=async()=>null,onError=async()=>null) {
  try {
    const response = await iq_api_v2.post("contact/enrich_contact", {
      apollo_user_id: apolloId,
      user_id: userId,
    });
    if (!response?.data?.email) {
      throw "Email Not Forund"
    }
    await onSuccess(response?.data?.email);
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    await onError();

  }
}



export async function enrichContactV2(userId, apolloId, phoneAccess,onSuccess=async()=>null,onError=async()=>null) {
  try {

    const base ={
       apollo_user_id: apolloId,
      user_id: userId,
    }

    if (phoneAccess) {
      base.enrich_phone = true
    }
    const response = await iq_api_v2.post("contact/enrich_contact_v2", base);
    if (!response?.data?.email) {
      throw "Email Not Forund"
    }
    if (phoneAccess && response?.data?.phone) {
       throw "Phone Not Forund"
    }
    await onSuccess(response?.data?.email);
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    await onError();

  }
}


export async function addContactBulkAsync(payload) {
  try {
    const response = await iq_api_v2.post("contact/add_contact_bulk_async", payload);
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    throw error;
  }
}
export async function markReadByUser(userId, opportunityId) {
  try {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("opportunity_id", opportunityId);

    const response = await iq_api_v2.patch("opportunities/update_read_status", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);

  }
}



export const fetchDocumentsV3 = async (compId) => {
  if (!compId) return [];

  try {
    const formData = new FormData();
    formData.append("ciq_id", compId);
    formData.append("timestamp", Date.now());

    const response = await iq_api_v2.post(
      `/company/get_files`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }
    );

    return response?.data?.records ?? [];
  } catch (error) {
    console.error("Fetch Documents error:", error);
    return [];
  }
};


export const fetchAccPlanPositiveNegative = async (client, account) => {
  try {
    const response = await iq_api_v2.post(
      `/company/positive_negative`,
      {}, // empty body
      {
        params: {
          client,
          account,
        },
      }
    );

    const result = response?.data?.data ?? [];
    return result || [];
  } catch (error) {
    console.error("Fetch Documents error:", error);
    throw error;
  }
};


export const fetchRecentConversations = async (accountName) => {

  try {
    const formData = new FormData();
formData.append("company", accountName);
  const response = await iq_api_v2.post("/company/recent_conversation", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
    return response.data; // extract and return only the data
  } catch (error) {
    console.error("fetchRecentConversations Data error:", error);
    throw error;
  }
};



export async function markContactfavByUser(userId,contactId, opportunityId) {
  try {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("contact_id", contactId);
    formData.append("opportunity_id", opportunityId);

    const response = await iq_api_v2.post("contact/shortlist_contact", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);

  }
}

export async function toogleOppBookmark(oppId, userId, postCall = () => null) {
  let data, error;
  try {
    const res = await iq_api_v2.post("opportunities/bookmark", {
      opportunities_id: [oppId],
      user_id: userId,
    }, { headers: { "Content-Type": "application/json" } });

    data = res?.data;
    return data;
  } catch (e) {
    error = e;
    console.error("Error:", e.response ? e.response.data : e.message);
    data=undefined;
    return undefined;
  } finally {
    postCall(data, error);
  }
}


export async function toogleSpotContactBookmark(contactId, userId, postCall = () => null) {
  let data, err;
  try {
    const formData = new FormData();
    formData.append("contact_id", contactId);
    formData.append("user_id", userId);

    const response = await iq_api_v2.post(
      "/contact/bookmark_contact_global",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    data = response?.data;
    return data;
  } catch (error) {
    err = error;
    console.error("Error:", error?.response?.data || error.message);
    data=undefined;
    return undefined;
  } finally {
    postCall(data, err);
  }
}



export async function aiChatInit(userInput, clientName, accountName) {
  try {
    const formData = new FormData();
    formData.append("user_input", userInput);
    formData.append("client_name", clientName);
    formData.append("account_name", accountName);

    const response = await fetch(`${IQ_API_V2_BASE_URL}/chat`, {
      method: "POST",
      body: formData,
      headers: {
        // Don't set Content-Type for FormData; browser will set it correctly
      },
    });

    if (!response.ok) throw new Error("Network response was not ok");
    return response;
  } catch (err) {
    console.error("❌ aiChatInit error:", err);
    return false;
  }
}

export async function aiChatInitV2(signal,saveToken,userInput, clientName,sessionId, accountName="",webCall=true) {
  try {
    const formData = new FormData();
    formData.append("user_input", userInput);
    formData.append("client_name", clientName);
    formData.append("account_name", accountName);
    formData.append("web_call", webCall);
    formData.append("session_id",sessionId);
    formData.append("saveToken",saveToken);
    
    const response = await fetch(`${IQ_API_V2_BASE_URL}/v2/chat`, {
      method: "POST",
      body: formData,
      headers: {
        // Don't set Content-Type for FormData; browser will set it correctly
      },
      signal:signal
    });

    if (!response.ok) throw new Error("Network response was not ok");
    return response;
  } catch (err) {
    console.error("❌ aiChatInit error:", err);
    return false;
  }
}



export async function generateContactBattlecardDetails(
  contactName,
  linkedInUrl,
  contactOrg,
  sellerOrg
) {
  try {
    const response = await iq_api_v2.post(
      "/contact/generate_contact_battlecard_details",
      null,
      {
        params: {
          contact_name: contactName,
          linkedin_url: linkedInUrl,
          contact_org: contactOrg,
          seller_org: sellerOrg,
        },
      }
    );
    if (response.status === 201 || response.status === 200) {
      return response?.data?.task_id;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
}


export async function saveChatHistory(question,answer,currentSessionId,clientName,accountName){
    try {
      const response = await api.post("/chat/save_record", {
        question: question,
        answer: answer || "",
        session_id: currentSessionId,
        client_name:clientName,
        account_name:accountName
    });

    if (response.data.status === 201 || response.data.status === 200) {
        return true
      } else {
       return false
      }
    } catch (err) {
      return false
    }
}


export async function saveChatHistoryByToken(
  question,
  answer,
  currentSessionId,
  clientName,
  accountName,
  token   // 👈 pass token from outside
) {
  try {
    const response = await fetch(`${API_BASE_URL}/chat/save_record`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "", // 👈 Auth header
      },
      body: JSON.stringify({
        question: question,
        answer: answer || "",
        session_id: currentSessionId,
        client_name: clientName,
        account_name: accountName,
      }),
    });

    // Handle non-200 status safely
    if (!response.ok) return false;

    const data = await response.json();

    return data?.status === 201 || data?.status === 200;
  } catch (err) {
    return false;
  }
}


export async function getChatHistoryPerSession(session_id){
    try {
          const response = await api.post("/chat/get_previous_chats", {
        session_id: session_id,
      });

    if (response.data.status === 201 || response.data.status === 200) {
        return response?.data?.data
      } else {
         return false
      }
    } catch (err) {
      return false
    }
}


export const getChatHistoryChips = async () => {
    try {
      const response = await api.get("/chat/get_history", {});
      // console.log(response);
      if (response.status === 201 || response.status === 200) {
        return response.data?.data || [];
        // console.log("response.data?.data || [] ", response.data?.data || [])
      } else {
      }
    } catch (err) {
       return null;
    }
    return;
  };



  export const updateContactReadBar= async(contactId,userId,postCall)=>{
      try {
    const response = await iq_api_v2.post(
      "contact/update_read_status_contact",
      {
        contact_id: contactId,
        user_id: userId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    postCall(response)
    return response?.data;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
    return null;
  }
  }



export async function getContactBattleCard(contactName, linkedInUrl, contactOrg, sellerOrg) {
  try {
    const queryParams = new URLSearchParams({
      contact_name: contactName,
      linkedin_url: linkedInUrl,
      contact_org: contactOrg,
      seller_org: sellerOrg,
    }).toString();

    const response = await iq_api_v2.post(`contact/get_contact_battle_card?${queryParams}`, null, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response?.data;
  } catch (err) {
    console.error("❌ getContactBattleCard error:", err);
    return false;
  }
}

export async function createCampaign(dataObj) {
  console.log("createCampaign request body",dataObj)

  return iq_auto_nurture_api.post("/campaign/create", dataObj)
    .then(response => {
      console.log("Campaign created successfully:", response.data);
      return response.data;
    })
    .catch(error => {
      console.error("Error creating campaign:", error);
      throw error;
    });
}

export async function generateTemplateForEmails(
  clientName,
  accountName,
  // products,
  campaignName,
  campaignContext,
  contactId,
  campaignId
) {
  console.log(
    "createCampaign request body",
    clientName,
    accountName,
    // products,
    campaignName,
    campaignContext,
    contactId,
    campaignId
  );

  return iq_auto_nurture_api
    .post(
      "/campaign/generate_templates",
      {},
      {
        params: {
          client: clientName,
          account: accountName,
          // products:products,
          campaign_name: campaignName,
          campaign_context: campaignContext,
          contact_id:contactId,
          campaign_id:campaignId
        },
      }
    )
    .then((response) => {
      console.log("template created successfully:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating Template:", error);
      throw error;
    });
}

export async function generateTempalteByContacts(
  clientName,
  accountName,
  campaignName,
  campaignContext,
  contactIds=[],
  userId,
  campaignId
) {
  console.log(
    "createCampaign request body",
    clientName,
    accountName,
    contactIds,
    campaignName,
    campaignContext,
    userId,
    campaignId
  );

  return iq_auto_nurture_api
    .post(
      "/campaign/generate_templates_by_contacts",
      contactIds,
      {
        params: {
          client: clientName,
          account: accountName,
          // products:products,
          campaign_name: campaignName,
          campaign_context: campaignContext,
          user_id:userId,
          campaign_id:campaignId
        },
      }
    )
    .then((response) => {
      console.log("template created successfully:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error creating Template:", error);
      throw error;
    });
}

///preview_campaign_details
export async function previewCampaignDetails(campaignId) {
  console.log("createCampaign request body", campaignId);

  return iq_auto_nurture_api.get("/campaign/preview_campaign_details", {
    params: {
      campaign_id: campaignId
    }
  })
    .then(response => {
      // console.log("preview successfully created:", response.data);
      return response.data;
    })
    .catch(error => {
      console.error("Error creating preview:", error);
      throw error;
    });
}



export async function getContactWiseTemplates(campaignId) {
  console.log("get_contactwise_templates request body", campaignId);

  return iq_auto_nurture_api.get("/campaign/get_contactwise_templates", {
    params: {
      campaign_id: campaignId
    }
  })
    .then(response => {
      // console.log("preview successfully created:", response.data);
      return response.data;
    })
    .catch(error => {
      console.error("Error creating preview:", error);
      throw error;
    });
}

export async function getPageWiseUserCampaignList(userId, pageType) {
  console.log("getPageWiseUserCampaignList request body:", { userId, pageType });

  const params = { user_id: userId };
  if (pageType) params.pagetype = pageType; // ✅ only include if present

  try {
    const response = await iq_auto_nurture_api.get(
      "/campaign/pagewise_users_campaign_list",
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching page-wise user campaign list:", error);
    return [];

  }
}


export async function addContactsToCampaign(campaignId, contactslist,searchList={}) {
  console.log("addContactsToCampaign payload", { campaignId, contactslist,searchList });

  return iq_auto_nurture_api.post(
    "/campaign/add_contacts",
    
      {contacts:contactslist,
       search_list:[searchList]
      }
    ,
    {
      params: {
        campaign_id: campaignId
      }
    }
  )
  .then(response => {
    console.log("Contacts successfully added:", response.data);
    return response.data;
  })
  .catch(error => {
    console.error("Error adding contacts:", error?.response?.data || error.message);
    throw error;
  });
}

export async function nurtureContactSearchSave(campaignId,searchList={}) {
  console.log("nurtureContactSearchSave payload", { searchList });

  return iq_auto_nurture_api.post(
    "/campaign/save_search_list",
    
      
       [searchList]
      
    ,
    {
      params: {
        campaign_id: campaignId
      }
    }
  )
  .then(response => {
    console.log("Contacts successfully added:", response.data);
    return response.data;
  })
  .catch(error => {
    console.error("Error adding contacts:", error?.response?.data || error.message);
    throw error;
  });
}

export async function nurtureContactSearchSaveFromGlobalContacts(campaignId,searchList={}) {
  console.log("nurtureContactSearchSaveFromGlobalContacts payload", { searchList });

  return iq_auto_nurture_api.post(
    "/campaign/save_contact_search_filters",
    
      
       [searchList]
      
    ,
    {
      params: {
        campaign_id: campaignId
      }
    }
  )
  .then(response => {
    console.log("Contacts successfully added:", response.data);
    return response.data;
  })
  .catch(error => {
    console.error("Error adding contacts:", error?.response?.data || error.message);
    throw error;
  });
}

export async function  checkContactExistsInCampaign(client,account,contactIds=[]){

   return iq_auto_nurture_api.post(
    "/campaign/check_contact_exists_in_campaign",
    
      {account:account,
       client:client,
       enrich_contactid:contactIds
      }
    
  )
  .then(response => {
    console.log("checkContactExistsInCampaign successful:", response?.data?.enrich_data);
    const finalData = response?.data?.enrich_data
    return finalData||[];
  })
  .catch(error => {
    console.error("Error checkContactExistsInCampaign : ", error?.response?.data || error.message);
   return []
  });
}

export async function deleteCampaignContacts(campId,dbId) {
  console.log("deleteCampaignContacts payload", {campId, dbId });

  return iq_auto_nurture_api.post(
    "/campaign/delete_contacts",
   
     [dbId],
      {params:{ campaign_id:campId}},
      
    
  )
  .then(response => {
    console.log("Contacts successfully added:", response.data);
    return response.data;
  })
  .catch(error => {
    console.error("Error adding contacts:", error?.response?.data || error.message);
    throw error;
  });
}

export async function addTempaltesToCampaign(campaignId, emailsList) {
  console.log("addTempaltesToCampaign payload", { campaignId, emailsList });

  return iq_auto_nurture_api.post(
    "/campaign/add_templates",
    
      emailsList
    ,
    {
      params: {
        campaign_id: campaignId
      }
    }
  )
  .then(response => {
    console.log("Contacts successfully added:", response.data);
    return response.data;
  })
  .catch(error => {
    console.error("Error adding contacts:", error?.response?.data || error.message);
    throw error;
  });
}

export async function userClientData(userId, clientName, currentRole) {
  try {
    // Validate input
    if (!userId || typeof userId !== 'string') {
      throw new Error('Invalid or missing userId');
    }
    if (!clientName || typeof clientName !== 'string') {
      throw new Error('Invalid or missing clientName');
    }

    // Role handling fallback
    const is_admin_logged_in = currentRole === 'CLIENT' ? 1 : 0;

    const requestBody = qs.stringify({
      user_id: userId,
      client: clientName,
      is_admin: is_admin_logged_in,
    });

    const response = await iq_api_v2.post(
      `/user_profile/get_personalisation`,
      requestBody,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );

    if (!response?.data) {
      throw new Error('No response data received');
    }

    const data = response.data.result;

    if (!data) {
      console.warn('API returned success, but "result" is empty or undefined.');
      return null;
    }

    return data;

  } catch (error) {
    console.error('Error fetching user client data:', error.message || error);
    return null; // or you could return a specific error object
  }
}


export async function finalSubmitCampaign(campaignId) {
  console.log("finalSubmitCampaign payload", { campaignId });

  const requestBody = qs.stringify({
    c_id: campaignId,
    status: 1,
  });

  return iq_auto_nurture_api.post(
    "/campaign/update",
    requestBody,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      params: {
        process_next: true,
      },
    }
  )
  .then(response => {
    console.log("Campaign submitted successfully:", response.data);
    return response.data;
  })
  .catch(error => {
    console.error("Error submitting campaign:", error?.response?.data || error.message);
    throw error;
  });
}




export async function getCampaignDetailsPerContact(pageType, userId, contactId, oppId) {
  console.log("getCampaignDetailsPerContact payload", { pageType, userId, contactId, oppId });

  // Base payload
  const payload = {
    // page_type: pageType,
    user_id: userId,
    opportunity_id: oppId,
  };

  // Add optional field only if provided
  if (contactId) {
    payload.for_contact_id = contactId;
  }

  return iq_auto_nurture_api
    .post("/campaign/get_for_conatct_campaign_details", payload)
    .then((response) => {
      console.log("Campaign details fetched successfully:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error("Error fetching campaign details:", error?.response?.data || error.message);
      throw error;
    });
}


export async function editTemplate(
  clientName,
  accountName,
  currentSubject,
  currentTremplate,
  prompt,
  contactId,
  campaignId
) {
  console.log("edit_template payload", {
    clientName,
    accountName,
    currentSubject,
    currentTremplate,
    prompt,
    campaignId,
    contactId
    
  });

  return iq_auto_nurture_api
    .post(
      "/campaign/edit_template",

      {},
      {
        params: {
          client: clientName,
          account: accountName|| "",
          current_subject: currentSubject,
          campaign_id:campaignId,
          current_template: currentTremplate,
          prompt,
          contact_id:contactId
        },
      }
    )
    .then((response) => {
      console.log(" successfully edit_template:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error(
        "Error edit_template",
        error?.response?.data || error.message
      );
      throw error;
    });
}


export async function findConactsFromVendor(payload){
  try {
    const response = await iq_api_v2.post("contact/contact_filters_advanced", payload);
    if (Array.isArray(response?.data?.contacts)) {
      response.data.contacts = response.data.contacts.map(item => ({
        ...item,
        caseType: "search",
      }));
    }
    console.log("findConactsFromVendor",response)
    return response; // now response.data.contacts has caseType
  } catch (error) {
    console.error("error", error);
    return null;
  }
}
export async function findCompanyDetails(payload){
  try{
    const response = await iq_api_v2.post("company/company_filters_advanced", payload);
    if (Array.isArray(response?.data?.contacts)) {
      response.data.contacts = response.data.contacts.map(item => ({
        ...item,
        caseType: "search",
      }));
    }
    console.log("findConactsFromVendor",response)
    return response?.data?.organizations;
  }
  catch (error) {
    console.error("error", error);
    return [];
  }
}
export async function findConactsFromVendorForNurture(payload){
  try {
    const response = await iq_api_v2.post("contact/contact_filters", payload);
    if (Array.isArray(response?.data?.contacts)) {
      response.data.contacts = response.data.contacts.map(item => ({
        ...item,
        caseType: "search",
      }));
    }
    console.log("findConactsFromVendor",response)
    return response; // now response.data.contacts has caseType
  } catch (error) {
    console.error("error", error);
    return null;
  }
}



export async function getAnalyticsByCampId(campaignID) {

  try {
    // This appends campaign_id as a query string param like ?campaign_id=xyz
    const response = await iq_auto_nurture_api.get("campaign/get_analytics", {
      params: {
        campaign_id: campaignID,
      },
    });
    return response;
  } catch (error) {
    console.error("error in getAnalyticsByCampId", error);
    return null;
  }
}


export async function updateTemplate(templateID, subject, body, dateToSend) {
  console.log("addContactsToCampaign payload", {
    templateID, subject, body, dateToSend
  });

  return iq_auto_nurture_api
    .post(
      "/campaign/update_template",

      { subject: subject, bodycontent: body,
        //  date_to_send: dateToSend 
        },
      {
        params: {
          template_id: templateID,
        },
      }
    )
    .then((response) => {
      console.log("Contacts successfully added:", response.data);
      return response.data;
    })
    .catch((error) => {
      console.error(
        "Error adding contacts:",
        error?.response?.data || error.message
      );
      throw error;
    });
}



  export const fetchOutlookToken = async (user_id) => {
    try {
        if (user_id) {
          const outlook_data = await iq_api_v2.get(
            `/outlook/has_valid_token?user_id=${user_id}`
          );
          // console.log("outlook_data?.data : ", outlook_data?.data )
          const is_connected = outlook_data?.data?.is_valid == 1 ? true : false;
          return is_connected;
        }
    } catch (error) {
      return false;
    }
  };


export const getAuthorizedUsersList  = async ()=>{
  try {
     const authData = await iq_auto_nurture_api.get(
        `/campaign/get_authorized_users_list`
      );

  return authData;
  } catch (error) {
    return [];
  }
 
}


export const getAccountwiseCampaignList = async (
  clientName,
  accountName,
  oppId,
  contactId
) => {
  try {
    const params = {
      client: clientName,
      account: accountName,
    };

    if (oppId) params.opportunity_id = oppId;
    if (contactId) params.for_contactid = contactId;

    const accWiseData = await iq_auto_nurture_api.get(
      `/campaign/accountwise_campaign_list`,
      { params }
    );

    return accWiseData;
  } catch (error) {
    return [];
  }
};


export async function changeCampaignDate(newDate,campaignID, userId,postCall=()=>null) {
  console.log("changeCampaignDate payload", newDate,campaignID, userId);
  // return true;

  try {
    const response = await iq_auto_nurture_api.post(
      `queue/change_campaign_date/${campaignID}`,
      null,
      {
        params:{
          campaignID,
        newdate: formatDateToYMD(new Date(newDate)),
        user_id: userId, campaign_id: campaignID}
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    postCall()
    return response?.data;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
     return 0;
  }
}



export async function createMemory(
  prompt,
  client,
  account,
  user_id,
  memory_type,
  is_admin = 0,
  use_case_name,
  web_url,
  offering_name,
  opp_id,
  tag_name,
  file_ids,
  tabs
) {
  try {
    const formData = new FormData();

    // Helper function to safely append values (fallback to empty string)
    const safeAppend = (key, value) => {
      formData.append(key, value ?? "");
    };

    safeAppend("prompt", prompt);
    safeAppend("client", client);
    safeAppend("account", account);
    safeAppend("user_id", user_id);
    safeAppend("memory_type", memory_type);
    safeAppend("is_admin", is_admin);

    safeAppend("use_case_name", use_case_name);
    safeAppend("web_url", web_url);
    safeAppend("offering_name", offering_name);
    safeAppend("opp_id", opp_id);
    safeAppend("tag_name", tag_name);
    safeAppend("file_ids", file_ids);
    safeAppend("tabs", tabs);

    const finalResponse = await iq_api_v2.post(
      "build_memory/create_memory",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return finalResponse?.data;
  } catch (error) {
    console.error(
      "Error createMemory:",
      error.response ? error.response.data : error.message
    );
  }
}

export async function getKeyDevelopmentByCompanyId(compId) {
  try {
    const formData = new FormData();
    formData.append("company_id", compId); // ✅ key name must match API requirement

    const resp = await iq_api_v2.post(
      "company/get_key_developments",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
    );

    return resp?.data;
  } catch (error) {
    console.error("getKeyDevelopmentByCompanyId error:", error);
    throw error;
  }
}



export default iq_api_v2;





export async function getSavedGlobalContactsPerUserId(userId) {
  try {
    const formData = new FormData();
    formData.append("user_id", userId); // ✅ key name must match API requirement

    const resp = await iq_api_v2.post(
      "contact/get_user_filters",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
    );


      const formatted = resp?.data
        ?.map((item) => ({
          id: item?._id || null,
          name: item?.name || null,
          contacts: item?.filters?.contacts || [],
          defaultList: item?.filters?.defaultList || false,
        }))
        // ---- Sort so defaultList === true always comes first ----
        ?.sort((a, b) => (b.defaultList === true) - (a.defaultList === true));
      return formatted;
  } catch (error) {
    console.error("getSavedGlobalContactsPerUserId error:", error);
    throw error;
  }
}



export async function deleteContactFilter(filterId) {
  try {
    const formData = new FormData();
    formData.append("filter_id", filterId); // ✅ key name must match API requirement

    const resp = await iq_api_v2.post(
      "contact/delete_user_filters",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
    );


    return resp?.data;
  } catch (error) {
    console.error("deleteContactFilter error:", error);
    return false

  }
}


export async function saveGlobalContactsInList(payload){
  try{
    const response = await iq_api_v2.post("contact/save_filters", payload);
  
    return response?.data;
  }
  catch (error) {
    console.error("error while saveGlobalContactsInList", error);
    return false;
  }
}

export async function appendContactToFilter(payload){
   try{
    const response = await iq_api_v2.post("contact/append_contact_to_filter", payload);
  
    return response?.data;
  }
  catch (error) {
    console.error("error while appendContactToFilter", error);
    return false;
  }
}


export async function loadContactsByFilter(filterId){
  try {
     const formData = new FormData();
    formData.append("filter_id", filterId); 

    const resp = await iq_api_v2.post(
      "contact/load_contacts_by_filter",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
    );
    return resp?.data;
  } catch (error) {
    
  }
}


export async function getContactsFromCredits(userId="66ff739203723f0dfb9ea793"){
  try {
     const formData = new FormData();
    formData.append("user_id", userId); 

    const resp = await iq_api_v2.post(
      "contact/get_contacts_from_credits",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
    );
    return resp?.data;
  } catch (error) {
    
  }
}

export async function getCreditBalance(userId) {
  try {
    const formData = new FormData();
    formData.append("user_id", userId); // ✅ key name must match API requirement

    const resp = await iq_api_v2.post(
      "credit/get_balance",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
    );
    return resp?.data;
  } catch (error) {
    console.error("deleteContactFilter error:", error);
    return false

  }
}

export async function getCreditTransactions(userId) {
  try {
    const formData = new FormData();
    formData.append("user_id", userId); // ✅ key name must match API requirement

    const resp = await iq_api_v2.post(
      "credit/get_transactions",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
    );
    return resp?.data;
  } catch (error) {
    console.error("deleteContactFilter error:", error);
    return false

  }
}

export async function saveGlobalAccountsInList(payload){

  try{
    const response = await iq_api_v2.post("company/save_my_companies_to_list", payload);
  
    return response?.data;
  }
  catch (error) {
    console.error("error while saveGlobalContactsInList", error);
    return false;
  }
}

export async function getUserGlobalAccountsNameList(userId, name = ""){

  try{
    const response = await iq_api_v2.get("company/get_user_global_accounts_saved_list_names", {
      params: { user_id: userId, name: name},
    });
  
    return response?.data;
  }
  catch (error) {
    console.error("error while saveGlobalContactsInList", error);
    return false;
  }
}

export async function deleteUserGlobalAccountsListByName(payload){

  try{
    const response = await iq_api_v2.post("company/delete_user_company_list", payload);
  
    return response?.data;
  }
  catch (error) {
    console.error("error while saveGlobalContactsInList", error);
    return false;
  }
}